import { activeView, updateVisibleStates } from "../subdiagram-viewer";
import { actionState } from "./action-state";
import RappidContext from "./rappid-context";

export function undo(context: RappidContext) {
  actionState.isUndo = true;
  context.commandManager.undo({ mergeArrays: true });
  updateVisibleStates(context, activeView.value);
  actionState.isUndo = false;
}

export function redo(context: RappidContext) {
  actionState.isRedo = true;
  context.commandManager.redo({ mergeArrays: true });
  updateVisibleStates(context, activeView.value);
  actionState.isRedo = false;
}
